export default "__VITE_ASSET__D8F_Spk0__"